<app-header #header></app-header>
<!-- You might notice that 'collapsed' is misspelled here. The framework does that. Fun! -->
<div class="page-body" [class.sidebar-collpased]="header.sidebarState">
  <app-sidebar></app-sidebar>
  <div class="page-content-wrapper">
    <div class="page-content-wrapper-inner">
      <div class="content-viewport">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

<app-notification></app-notification>
<app-loading></app-loading>
